define('superAdminMbAModelsView',[
    'module',
    'marionette',
    'underscore',
    'app',
    'settings',
    'jqgridView',
    'template!superAdminMbAModelsListTpl'
], function (
    module,
    Marionette,
    _,
    App,
    Settings,
    JqGridView,
    viewTpl
    ) {
    'use strict';

    var MbAModelListView = JqGridView.extend({
        template: viewTpl,
        filtersName: 'mbamodelsListFilters',

        triggers: {
        },

        ui: function() {
            return _.extend({
                jqGrid: '#jq-grid-list',
                jqGridPager: '#jq-grid-pager-list',
                deleteMbAModel: '.delete-mbamodel-link'
            }, this.gridUi);
        },

        events: function() {
            return _.extend({
                'click @ui.deleteMbAModel': 'onDeleteMbAModel'
            }, this.gridEvents);
        },

        serializeData: function() {
            var templateData = {type: 'mbamodels'};

            return templateData;
        },

        pagination: function() {
            return {
                first: 0,
                rowCount: 0,
                pageSize: Settings.get('perPage15'),
                currentPage: 1
            };
        },

        onDeleteMbAModel: function(event){
            this.trigger('mbamodel:delete', $(event.currentTarget).find('span').attr('data-row-id'));
        },

        gridOptions: function(data) {
            var options = {
                colModel: [
                    {
                        label: '',
                        name: 'secId',
                        key: true,
                        hidden: true
                    }, {
                        label: _.i18n('common.code'),
                        name: 'code',
                        classes: 'mbamodel-link',
                        formatter:  this.defaultFormatter,
                        search: false,
                        index: 'code'
                    }, {
                        label: _.i18n('common.name'),
                        name: 'name',
                        classes: 'mbamodel-link',
                        formatter:  this.defaultFormatter,
                        search: false,
                        index: 'name'
                    }, {
                        label: _.i18n('mbamodel.dispatcher'),
                        name: 'dispatcher',
                        classes: 'mbamodel-link',
                        formatter:  this.booleanFormatter,
                        search: false,
                        index: 'dispatcher'
                    }, {
                        label: _.i18n('mbamodel.extractor'),
                        name: 'extractor',
                        classes: 'mbamodel-link',
                        formatter:  this.booleanFormatter,
                        search: false,
                        index: 'extractor'
                    }, {
                        label: _.i18n('mbamodel.cycler'),
                        name: 'cycler',
                        classes: 'mbamodel-link',
                        formatter:  this.booleanFormatter,
                        search: false,
                        index: 'cycler'
                    }, {
                        label: _.i18n('mbamodel.other'),
                        name: 'other',
                        classes: 'mbamodel-link',
                        formatter:  this.booleanFormatter,
                        search: false,
                        index: 'other'
                    }, {
                        label: ' ',
                        name: 'delete',
                        search: false,
                        classes: 'delete-mbamodel-link delete-link',
                        formatter: this.deleteIconFormatter,
                        width: 20
                    }
                ],

                onSelectRow: function(rowId, bool, e) {
                    if (!$(e.target).hasClass('cell-delete') && e.type === 'click') {
                        if (e.type === 'click') {
                            var route = App.getCurrentRoute() ===  'superAdmin/mbamodels' ?
                                App.getCurrentRoute() : 'superAdmin/mbamodels/' + App.getCurrentRoute();
                            App.navigate(route + '/' + rowId, {trigger: true});
                        }
                    }
                }
            };

            options = _.defaults(options, this.gridInitOptions(data));

            return options;
        }
    });

    module.exports = MbAModelListView;
});
